import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=3d45bb64&scoped=true&"
import script from "./AddRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddRoleModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45bb64",
  null
  
)

export default component.exports